
export enum CheckpointEventStatusCd {
	CANCELLED = 'Cancelled',
	OPEN = 'Open',
	PROCESSED = 'Processed'}
